import IJitRepository from '../domain/IJitRepository';
import { loadTransists } from '../domain/TransitsData';
import { LoadDTO, LoadDTOAmount } from '../infrastructure/dto/TransitsDTO';
import jitRepository from '../infrastructure/repositories/JitRepository';

class EditTransitsService {
  private readonly _jitRepository: IJitRepository;

  constructor({ repository }) {
    this._jitRepository = repository;
  }
  private formatDate(dateString: string, timeString: string): string {
    const formattedTimeString = timeString.replace('h', '').trim();
    const [day, month, year] = dateString
      .split('/')
      .map((part) => parseInt(part, 10));
    const [hour, minute] = formattedTimeString
      .split(':')
      .map((part) => parseInt(part, 10));

    const date = new Date(year, month - 1, day, hour, minute, 0);

    const pad = (n: number) => n.toString().padStart(2, '0');
    const localIso = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
      date.getSeconds()
    )}`;

    return localIso;
  }
  execute({ body }: { body: loadTransists }): Promise<LoadDTOAmount> {
    const bodyFormated: LoadDTO = {
      id: body.id,
      plate_number: body.plateNumber,
      delivery_time: this.formatDate(body.deliveryTimeDate, body.deliveryTime),
      quantity: body.amount,
      provider_delivery_note: body.providerDeliveryNote
    };
    return this._jitRepository
      .editJitTransits({ body: bodyFormated })
      .then((res) => res);
  }
}

export default new EditTransitsService({ repository: jitRepository });

export { EditTransitsService };
